import { Company } from '@ninety/platform/models/company/company';

export const initialCompanyState: Company = null;
